import * as React from 'react';
import { IControlSchema } from "../../Controls";
import {Component, I18NString} from "../../Utils";
import Field from '../Field';

interface LabelProps {
    schema: IControlSchema;
}

class Label extends Component<LabelProps,{}>{
    render(){
        return (
            <Field {...this.props.schema}>
                <span></span>
            </Field>
        )
    }
}

export function createLabel(schema: IControlSchema){
    return <Label schema={schema}></Label>
}





// WEBPACK FOOTER //
// ./src/components/controls/standart/Label.tsx